import { FC } from 'react'
import { styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const Container = styled('div')({
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'url("/back.png")',
  backgroundSize: 'cover',
  backgroundColor: '#EFF3FD',
})

const LoginBox = styled('div')({
  background: '#FFFFFF',
  padding: '40px',
  borderRadius: '12px',
  border: '1px solid #E0E0E0',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  width: '400px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
})

const LoginButton = styled('button')({
  width: '100%',
  padding: '15px',
  border: 'none',
  borderRadius: '8px',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  fontSize: '16px',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  '&:hover': {
    backgroundColor: '#e9ecef',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
})

const Title = styled('h1')({
  color: '#495057',
  marginBottom: '20px',
  fontFamily: 'Gabarito',
  textAlign: 'center',
  fontSize: '24px',
})

const SubTitle = styled('h2')({
  color: '#495057',
  marginBottom: '20px',
  fontFamily: 'Gabarito',
  textAlign: 'center',
  fontSize: '20px',
  fontWeight: '500',
})

interface LoginProps {}

export const Login: FC<LoginProps> = () => {
  const navigate = useNavigate()

  const handleLogin = (role: string) => {
    // Here you can add authentication logic if needed
    console.log(`Logging in as ${role}`)
    navigate('/dashboard')
  }

  return (
    <Container>
      <Title>YAMAHA PH</Title>
      <SubTitle>DEALER NETWORK DEVELOPMENT</SubTitle>

      <LoginBox>
        <LoginButton onClick={() => handleLogin('AC')}>LOGIN AS AC</LoginButton>

        <LoginButton onClick={() => handleLogin('BM')}>LOGIN AS BM</LoginButton>

        <LoginButton onClick={() => handleLogin('ME')}>LOGIN AS ME</LoginButton>

        <LoginButton onClick={() => handleLogin('GAPS')}>
          LOGIN AS GAPS
        </LoginButton>

        <LoginButton onClick={() => handleLogin('DNDPA')}>
          LOGIN AS DNDPA
        </LoginButton>
      </LoginBox>
    </Container>
  )
}
